const contractTeamsCount = {
	data: {
		total: 26,
		complete: 14
	},
	errors: []
};

const contractTeamsTemplateMarker = {
	data: [
		{
			id: 1416,
			name: 'AA Test Contract'
		},
		{
			id: 1411,
			name: 'BB Template Contract'
		},
		{
			id: 1447,
			name: 'DD Template Contract 7'
		},
		{
			id: 1,
			name: 'Deployment Template'
		},
		{
			id: 1921,
			name: 'MikeTest_October'
		},
		{
			id: 1442,
			name: 'Template Contract 1'
		},
		{
			id: 1450,
			name: 'Template Contract 10'
		},
		{
			id: 1451,
			name: 'Template Contract 11'
		},
		{
			id: 1452,
			name: 'Template Contract 12'
		},
		{
			id: 1443,
			name: 'Template Contract 2'
		},
		{
			id: 1437,
			name: 'Template Contract 2020'
		},
		{
			id: 1461,
			name: 'Template Contract 21'
		},
		{
			id: 1444,
			name: 'Template Contract 3'
		},
		{
			id: 1445,
			name: 'Template Contract 4'
		},
		{
			id: 1446,
			name: 'Template Contract 5'
		},
		{
			id: 1448,
			name: 'Template Contract 8'
		},
		{
			id: 1438,
			name: 'Template Contract Monthly'
		}
	],
	errors: []
};

const appointmentTeamsByGrouping = {
	'Marker': {
		"count": 70,
		"data": [
			"Accounting and Finance CSYS Dissertation",
			"Accounting and Finance CSYS Paper I",
			"Accounting and Finance CSYS Paper II",
			"Accounting and Finance Higher Grade Paper I",
			"Accounting and Finance Higher Grade Paper II",
			"Accounting and Finance Higher Grade Paper III",
			"Accounting and Finance Standard Grade  Foundation and General Levels",
			"Accounting and Finance Standard Grade General and Credit Levels",
			"Art and Design CSYS (Research and Appreciation)",
			"Art and Design Higher Grade Paper II",
			"Art and Design Standard Grade Critical Activity",
			"Biology CSYS Paper I",
			"Biology CSYS Paper II",
			"Biology Higher Grade Paper II",
			"Biology Standard Grade Credit Level",
			"Biology Standard Grade General Level",
			"Building and Architectural Technology Higher Level",
			"Care Higher Level Paper 1",
			"Central Marking",
			"Chemistry Advanced Higher Assignment",
			"Chemistry Advanced Higher Question Paper",
			"Chemistry CSYS Paper I",
			"Chemistry Higher Grade Paper II",
			"Chemistry Standard Grade Credit Level",
			"Chemistry Standard Grade General Level",
			"Civil Engineering Higher Level",
			"Classical Greek CSYS Dissertation",
			"Classical Greek CSYS Paper I",
			"Classical Greek Higher Grade Papers I and II",
			"Classical Greek Higher Interpretation",
			"Classical Greek Standard Grade Foundation Level (Interpretation)",
			"Classical Greek Standard Grade Investigation",
			"Classical Studies CSYS Dissertation",
			"Classical Studies CSYS Paper I",
			"Classical Studies CSYS Paper II",
			"Classical Studies Higher Grade Paper I",
			"Classical Studies Higher Grade Paper II",
			"Computing Studies Higher Grade Paper I",
			"Computing Studies Higher Grade Paper II",
			"Computing Studies Standard Grade Credit Level",
			"Computing Studies Standard Grade General Level",
			"Construction Higher Level",
			"Contemporary Social Studies Standard Grade Foundation Level",
			"Economics Higher Grade Paper II",
			"Electrical Engineering Higher Level",
			"Electronics Higher Level",
			"French CSYS Paper I",
			"Gaidhlig CSYS Paper II",
			"Human Biology Higher Grade Paper II",
			"Latin CSYS Paper I",
			"Managing Environmental Resources Higher",
			"Mandarin (Traditional) Advanced Higher Portfolio",
			"Mathematics Higher Level Paper II",
			"Mathematics Higher Paper 1",
			"Mechanical Engineering Higher Level",
			"Mechatronics Higher",
			"Media Studies Higher Level",
			"Modern Studies Advanced Higher Project: Dissertation",
			"Music Technology Higher Assignment",
			"Personal and Social Education Higher Level",
			"Physical Education Higher Grade Analysis of Performance",
			"Politics Higher Level Paper 1",
			"QA Advanced Higher",
			"Russian Higher Grade Papers I and II",
			"Russian Higher Reading and Directed Writing",
			"Russian Standard Grade Reading Foundation",
			"Sociology Higher Level Paper 1",
			"Sociology Higher Question Paper",
			"Spanish Higher Reading and Directed Writing",
			"Urdu Standard Grade Reading Foundation Level"
		],
		"errors": []
	},
	'Appointment Group': {
		"count": 2,
		"data": [
			"Health and Food Technology Advanced Higher",
			"Music Advanced Higher"
		],
		"errors": []
	},
	'Ad Hoc': {
		"count": 2,
		"data": [
			"Personal and Social Education Scrutineer",
			"Technological Studies Higher"
		],
		"errors": []
	},
	'Invigilator': {
		"count": 7,
		"data": [
			"EA Further Education Test1",
			"EA Secondary School  Test16",
			"Further Education College Test18",
			"Private Sector Employer  Test1",
			"South Eastern Education Authority",
			"Taylor High School",
			"Venue (outside Scotland) Test4"
		],
		"errors": []
	},
	'Verifier': {
		"count": 1,
		"data": [
			"SVQ Sport and Active Leisure:  Spectator Safety"
		],
		"errors": []
	}
};

export { contractTeamsCount, contractTeamsTemplateMarker, appointmentTeamsByGrouping };
